import StackedMenu from "stacked-menu/src/scripts/stacked-menu";

// theme
window.StackedMenu = StackedMenu;
window.PerfectScrollbar = require('perfect-scrollbar').default;
window.Looper = require('../looper/theme');

// custom plugins
window.VideoThumbnails = require('./custom-plugins/video-thumbnails');
require('./custom-plugins/bootstrap-btn-loading');
require('./custom-plugins/readmore');
